import React from 'react';

interface AnimatedCarProps {
  hasError?: boolean;
}

const AnimatedCar: React.FC<AnimatedCarProps> = ({ hasError = false }) => {
  return (
    <>
      <svg
        className={`animated-car${hasError ? ' car-error' : ''}`}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 800 800"
        width="700"
        height="700"
        style={{ enableBackground: 'new 0 0 800 800' } as React.CSSProperties}
      >
        <g>
          {/* ── GROUND SHADOW ── */}
          <ellipse
            style={{ opacity: 0.15, fill: '#404041' }}
            cx="411.345" cy="550.393" rx="293.073" ry="15.379"
          />

          {/* ── DARK BASE / UNDERCARRIAGE ── */}
          <polygon
            style={{ fill: '#162026' }}
            points="182.321,502.886 306.086,514.299 542.856,519.471 661.844,520.408 672.926,494.528 661.844,443.814 613.162,429.524 165.936,429.524"
          />

          {/* ── MAIN CAR BODY ── */}
          <path
            style={{ fill: '#558AA2' }}
            d="M706.213,464.433c0,0-2.123-29.087-11.959-42.247c0,0-5.956-6.094-23.963-10.25
              c0,0-51.344-11.774-109.89-15.838c0,0-39.154-27.795-81.265-52.451c0,0-26.408-11.45-60.762-11.45
              c0,0-216.02-5.85-258.643,3.544c-0.432,0.095-0.817,0.326-1.111,0.654l-2.342,2.613c-0.588,0.655-0.375,1.691,0.419,2.066
              l1.734,0.816c0.669,0.315,0.841,1.19,0.331,1.729c-4.359,4.606-21.169,23.524-28.695,48.817
              c-0.355,1.201-0.546,2.446-0.546,3.7v52.784c0,0-9.403,0.958-13.63,6.686l-1.605,14.922c0,0,1.199,18.655,11.91,22.163
              c0,0,38.209,8.163,56.124,10.195c0,0,2.104-25.787,9.122-44.441c0,0,8.445-22.268,42.429-22.268
              c0,0,49.126-0.37,55.407,18.099c0,0,7.572,20.5,10.711,44.325l6.096,15.698l236.77,5.171l2.217-16.252
              c0,0,4.432-43.587,16.622-53.56c0,0,9.05-7.756,37.858-7.756c0,0,48.022-0.924,53.932,20.129
              c0,0,7.941,21.794,8.495,53.746h34.905c0,0,4.342-3.786,6.004-7.572l-1.016-3.972l3.325-12.835h2.03
              c0,0,1.94-0.924,1.94-3.232c0-0.182,0-0.328,0-0.461l0.553-19.393C709.721,468.312,708.336,465.819,706.213,464.433z"
          />

          {/* ── BODY SHADING OVERLAY ── */}
          <g style={{ opacity: 0.2 }}>
            <path
              style={{ fill: '#bbd4d9ff' }}
              d="M707.229,491.398c0,0,1.94-0.924,1.94-3.232c0-0.182,0-0.328,0-0.461l0.553-19.393
                c0,0-1.385-2.493-3.508-3.879c0,0-0.135-1.829-0.488-4.776l-54.148-1.84c0.83,1.298,1.481,2.698,1.908,4.216
                c0,0,7.941,21.793,8.495,53.743h34.905c0,0,4.342-3.785,6.004-7.571l-1.016-3.972l3.325-12.835H707.229z"
            />
            <path
              style={{ fill: '#909596' }}
              d="M191.443,458.445c0,0,3.484-9.182,14.975-15.754l-76.895-2.613v8.842c0,0-9.403,0.958-13.63,6.686
                l-1.605,14.922c0,0,1.199,18.655,11.91,22.163c0,0,38.209,8.163,56.124,10.195C182.321,502.886,184.425,477.1,191.443,458.445z"
            />
            <path
              style={{ fill: '#909596' }}
              d="M545.072,503.219c0,0,3.426-33.671,12.531-48.595l-276.632-9.4
                c4.014,2.353,7.037,5.317,8.308,9.052c0,0,7.572,20.5,10.711,44.325l6.096,15.698l236.77,5.171L545.072,503.219z"
            />
          </g>

          {/* ── ROOF DARK STRIPE ── */}
          <path
            style={{ fill: '#4C7B91' }}
            d="M387.539,326.67c-82.74-9.604-192.861-1.754-192.861-1.754
              c-8.311,1.662-12.742,10.526-12.742,10.526h25.486l2.631-5.148c0.521-1.018,1.521-1.702,2.658-1.812
              c37.559-3.627,130.554-0.466,146.209,0.103c1.38,0.05,2.607,0.886,3.158,2.151l1.452,3.321h34.491
              C392.895,328.102,387.539,326.67,387.539,326.67z"
          />

          {/* ── GLASS HIGHLIGHT STRIP ── */}
          <path
            style={{ opacity: 0.2, fill: '#FFFFFF' }}
            d="M138.021,373.013h388.297c-13.656-8.942-30.176-19.41-47.182-29.366
              c0,0-26.408-11.45-60.762-11.45c0,0-216.02-5.85-258.643,3.544c-0.432,0.095-0.817,0.326-1.111,0.654l-2.342,2.613
              c-0.588,0.655-0.375,1.691,0.419,2.066l1.734,0.816c0.669,0.315,0.841,1.19,0.331,1.729
              C155.615,346.946,145.971,357.744,138.021,373.013z"
          />

          {/* ══════════ REAR WHEEL ══════════ */}
          <g style={{ animation: 'spin 0.6s linear infinite', transformOrigin: '241.566px 504.235px' }}>
            <circle style={{ fill: '#29212C' }} cx="241.566" cy="504.235" r="49.631" />
            <path
              style={{ fill: '#3F3643' }}
              d="M241.566,454.604c-27.408,0-49.629,22.224-49.629,49.631c0,27.411,22.221,49.628,49.629,49.628
                c27.412,0,49.628-22.218,49.628-49.628C291.194,476.829,268.978,454.604,241.566,454.604z M274.076,536.744
                c-4.223,4.223-9.141,7.538-14.615,9.853c-5.664,2.396-11.686,3.611-17.895,3.611s-12.229-1.215-17.894-3.611
                c-5.475-2.315-10.392-5.63-14.614-9.854c-4.223-4.222-7.539-9.139-9.854-14.613c-2.398-5.666-3.612-11.687-3.612-17.895
                c0-6.208,1.214-12.228,3.612-17.893c2.314-5.475,5.631-10.392,9.854-14.616c4.223-4.223,9.141-7.539,14.614-9.854
                c5.665-2.397,11.685-3.612,17.894-3.612s12.23,1.215,17.895,3.612c5.475,2.315,10.393,5.631,14.615,9.854
                c4.221,4.224,7.537,9.141,9.853,14.616c2.395,5.665,3.609,11.685,3.609,17.893c0,6.209-1.215,12.229-3.609,17.895
                C281.614,527.604,278.297,532.521,274.076,536.744z"
            />
            <path
              style={{ fill: '#3F3643' }}
              d="M241.566,465.514c-21.35,0-38.72,17.37-38.72,38.722c0,21.349,17.37,38.719,38.72,38.719
                c21.35,0,38.719-17.37,38.719-38.719C280.285,482.884,262.916,465.514,241.566,465.514z"
            />
            <circle style={{ fill: '#D0D2D3' }} cx="241.566" cy="504.23" r="34.506" />
            <circle style={{ fill: '#29212C' }} cx="241.566" cy="504.231" r="30.801" />
            {/* Spokes */}
            <path
              style={{ fill: '#919396' }}
              d="M272.359,507.464l0.018-6.468h-11.025c-0.213-1.333-0.558-2.622-1.021-3.854l9.558-5.511l-3.221-5.602
                l-9.561,5.512c-0.842-1.032-1.783-1.977-2.812-2.821l5.534-9.546l-5.593-3.233l-5.533,9.543
                c-1.232-0.466-2.52-0.814-3.854-1.031l0.028-11.023h-6.469l-0.028,11.023c-1.333,0.216-2.624,0.564-3.858,1.031l-5.486-9.543
                l-5.607,3.233l5.488,9.546c-1.035,0.844-1.982,1.79-2.83,2.821l-9.531-5.512l-3.249,5.602l9.53,5.511
                c-0.469,1.232-0.82,2.521-1.039,3.854h-11.023l-0.017,6.468h11.022c0.214,1.335,0.559,2.625,1.021,3.857l-9.557,5.51l3.219,5.603
                l9.561-5.512c0.842,1.031,1.785,1.976,2.814,2.821l-5.535,9.544l5.594,3.234l5.531-9.543c1.233,0.466,2.52,0.815,3.855,1.031
                l-0.027,11.023h6.467l0.029-11.023c1.334-0.216,2.625-0.565,3.857-1.031l5.487,9.543l5.608-3.234l-5.488-9.544
                c1.035-0.846,1.981-1.791,2.829-2.821l9.532,5.512l3.248-5.603l-9.529-5.51c0.469-1.232,0.818-2.522,1.039-3.857H272.359z"
            />
            <circle style={{ fill: '#29212C' }} cx="241.566" cy="504.231" r="9.417" />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M241.566,519.175c-8.24,0-14.939-6.703-14.939-14.94c0-8.239,6.699-14.941,14.939-14.941
                c8.238,0,14.939,6.702,14.939,14.941C256.506,512.472,249.805,519.175,241.566,519.175z"
            />
            <circle style={{ fill: '#CBCDCE' }} cx="241.566" cy="504.231" r="5.47" />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M241.566,484.643c-10.803,0-19.592,8.789-19.592,19.592c0,10.802,8.789,19.591,19.592,19.591
                c10.803,0,19.592-8.789,19.592-19.591C261.158,493.432,252.369,484.643,241.566,484.643z"
            />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M241.648,470.847c-18.436,0-33.421,14.947-33.465,33.384c-0.047,18.438,14.863,33.384,33.299,33.384
                c18.437,0,33.422-14.946,33.468-33.384C274.996,485.793,260.086,470.847,241.648,470.847z"
            />
          </g>

          {/* ══════════ FRONT WHEEL ══════════ */}
          <g style={{ animation: 'spin 0.6s linear infinite', transformOrigin: '603.461px 504.235px' }}>
            <circle style={{ fill: '#29212C' }} cx="603.461" cy="504.235" r="49.631" />
            <path
              style={{ fill: '#3F3643' }}
              d="M603.461,454.604c-27.408,0-49.629,22.224-49.629,49.631c0,27.411,22.221,49.628,49.629,49.628
                c27.412,0,49.629-22.218,49.629-49.628C653.09,476.829,630.873,454.604,603.461,454.604z M635.971,536.744
                c-4.223,4.223-9.14,7.538-14.615,9.853c-5.664,2.396-11.686,3.611-17.895,3.611c-6.209,0-12.228-1.215-17.894-3.611
                c-5.473-2.315-10.391-5.63-14.613-9.854c-4.223-4.222-7.539-9.139-9.854-14.613c-2.396-5.666-3.611-11.687-3.611-17.895
                c0-6.208,1.215-12.228,3.611-17.893c2.315-5.475,5.631-10.392,9.854-14.616c4.223-4.223,9.141-7.539,14.615-9.854
                c5.666-2.397,11.684-3.612,17.892-3.612c6.209,0,12.231,1.215,17.895,3.612c5.476,2.315,10.392,5.631,14.615,9.854
                c4.223,4.224,7.537,9.141,9.852,14.616c2.398,5.665,3.611,11.685,3.611,17.893c0,6.209-1.213,12.229-3.611,17.895
                C643.508,527.604,640.193,532.521,635.971,536.744z"
            />
            <path
              style={{ fill: '#3F3643' }}
              d="M603.461,465.514c-21.35,0-38.721,17.37-38.721,38.722c0,21.349,17.371,38.719,38.721,38.719
                c21.35,0,38.72-17.37,38.72-38.719C642.181,482.884,624.81,465.514,603.461,465.514z"
            />
            <circle style={{ fill: '#D0D2D3' }} cx="603.461" cy="504.23" r="34.506" />
            <circle style={{ fill: '#29212C' }} cx="603.461" cy="504.231" r="30.801" />
            {/* Spokes */}
            <path
              style={{ fill: '#919396' }}
              d="M634.254,507.464l0.016-6.468h-11.023c-0.212-1.333-0.557-2.622-1.019-3.854l9.557-5.511
                l-3.221-5.602l-9.559,5.512c-0.842-1.032-1.785-1.977-2.814-2.821l5.534-9.546l-5.592-3.233l-5.534,9.543
                c-1.231-0.466-2.52-0.814-3.853-1.031l0.026-11.023h-6.469l-0.027,11.023c-1.334,0.216-2.625,0.564-3.857,1.031l-5.488-9.543
                l-5.607,3.233l5.488,9.546c-1.034,0.844-1.982,1.79-2.828,2.821l-9.533-5.512l-3.248,5.602l9.529,5.511
                c-0.469,1.232-0.82,2.521-1.039,3.854h-11.023l-0.016,6.468h11.023c0.211,1.335,0.559,2.625,1.02,3.857l-9.559,5.51l3.223,5.603
                l9.559-5.512c0.845,1.031,1.785,1.976,2.814,2.821l-5.534,9.544l5.593,3.234l5.532-9.543c1.233,0.466,2.521,0.815,3.854,1.031
                l-0.027,11.023h6.468l0.027-11.023c1.335-0.216,2.627-0.565,3.858-1.031l5.487,9.543l5.608-3.234l-5.488-9.544
                c1.034-0.846,1.981-1.791,2.828-2.821l9.534,5.512l3.247-5.603l-9.53-5.51c0.47-1.232,0.821-2.522,1.042-3.857H634.254z"
            />
            <circle style={{ fill: '#29212C' }} cx="603.461" cy="504.231" r="9.417" />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M603.461,519.175c-8.238,0-14.941-6.703-14.941-14.94c0-8.239,6.703-14.941,14.941-14.941
                c8.238,0,14.941,6.702,14.941,14.941C618.402,512.472,611.699,519.175,603.461,519.175z"
            />
            <circle style={{ fill: '#CBCDCE' }} cx="603.461" cy="504.231" r="5.47" />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M603.461,484.643c-10.803,0-19.592,8.789-19.592,19.592c0,10.802,8.789,19.591,19.592,19.591
                c10.803,0,19.59-8.789,19.59-19.591C623.051,493.432,614.264,484.643,603.461,484.643z"
            />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M603.544,470.847c-18.436,0-33.421,14.947-33.466,33.384c-0.047,18.438,14.861,33.384,33.301,33.384
                c18.436,0,33.42-14.946,33.466-33.384C636.891,485.793,621.981,470.847,603.544,470.847z"
            />
          </g>

          {/* ── REAR WINDOW ── */}
          <path
            style={{ fill: '#312935' }}
            d="M147.254,394.898c0,0,15.236-39.615,30.195-54.852c0,0,76.184-1.661,98.348-1.939
              c0,0,6.094,1.478,2.029,8.311l-25.485,42.294c0,0-4.064,6.186-11.081,6.186C234.241,394.898,147.254,394.898,147.254,394.898z"
          />

          {/* ── FRONT WINDSHIELD ── */}
          <path
            style={{ fill: '#312935' }}
            d="M288.74,377.82c0.863-3.087,2.238-6.098,3.389-8.986c2.74-6.901,5.658-13.795,9.268-20.294
              c0.563-1.014,1.143-2.018,1.758-3.001c0.314-0.5,1.639-1.896,1.639-2.444c0,0,2.586-4.986,9.234-4.986
              c0,0,89.064,0.97,131.867,6.094c0,0,19.761,3.325,32.137,13.759l36.566,30.198c0,0,11.451,16.252-7.202,19.207
              c-18.653,2.954-202.419-6.833-202.419-6.833s-5.539-0.555-9.049-4.433c-2.252-2.489-5.801-5.27-7.252-8.305
              c-0.305-0.635-0.467-1.328-0.582-2.023C287.647,383.084,288.012,380.425,288.74,377.82z"
          />

          {/* ── WINDSHIELD PILLAR ── */}
          <path
            style={{ fill: '#312935' }}
            d="M479.364,343.781l-3.245,1.103c-0.934,0.317-1.082,1.572-0.246,2.095
              c8.172,5.119,39.012,24.764,69.396,48.426c1.184,0.921,2.658,1.387,4.156,1.304l10.976-0.61
              C560.401,396.099,521.387,368.403,479.364,343.781z"
          />

          {/* ── BODY DETAIL / SHADOW OVERLAY ── */}
          <g style={{ opacity: 0.4 }}>
            <path
              style={{ fill: '#909596' }}
              d="M275.797,338.107c-22.164,0.278-98.348,1.939-98.348,1.939
                c-14.959,15.237-30.195,54.852-30.195,54.852s86.987,0,94.006,0c7.018,0,11.081-6.186,11.081-6.186l25.485-42.294
                C281.891,339.585,275.797,338.107,275.797,338.107z"
            />
            <path
              style={{ fill: '#909596' }}
              d="M514.598,388.158l-36.568-30.198c-12.374-10.434-32.135-13.759-32.135-13.759
                c-42.803-5.124-131.867-6.094-131.867-6.094c-6.648,0-9.234,4.986-9.234,4.986c0,0.548-1.325,1.945-1.639,2.444
                c-0.615,0.983-1.195,1.987-1.758,3.001c-3.609,6.499-6.527,13.393-9.268,20.294c-1.15,2.888-2.527,5.899-3.389,8.986
                c-0.729,2.605-1.093,5.264-0.646,7.951c0.115,0.695,0.277,1.389,0.582,2.023c1.451,3.035,5,5.816,7.252,8.305
                c3.51,3.879,9.049,4.434,9.049,4.434s138.732,7.388,187.348,7.388c7.335,0,12.626-0.168,15.071-0.555
                C526.049,404.41,514.598,388.158,514.598,388.158z"
            />
          </g>

          {/* ── INTERIOR BODY SHADING ── */}
          <path
            style={{ opacity: 0.4, fill: '#909596' }}
            d="M533.16,398.5l-1.025-3.342c-0.955-3.11-2.867-5.839-5.463-7.799l-49.381-37.248
              c0,0-15.328-10.711-43.771-13.482l-134.729-2.955c0,0-20.225,34.629-25.764,64.549c0,0-2.588,24.134-3.725,42.299
              c9.425,2.647,17.646,6.904,19.977,13.754c0,0,7.572,20.5,10.711,44.325l3.621,9.327h224.283l5.266-18.561
              C533.16,489.367,544.242,439.501,533.16,398.5z"
          />

          {/* ── ANTENNA / ROOF MOUNT ── */}
          <path
            style={{ fill: '#1F1916' }}
            d="M547.287,412.167c0,0-0.9,8.103,1.316,10.781l24.311,0.139c0,0,6.049-3.717,6.418-8.703
              c0,0-0.277-1.847-3.416-1.847l-26.041-1.478C549.875,411.059,547.381,411.409,547.287,412.167z"
          />

          {/* ── TAIL LIGHT RED ── */}
          <path
            style={{ fill: '#A41E22' }}
            d="M147.254,394.898h-17.731c0,0-3.835,26.028,0,54.022h15.841
              C145.363,448.92,144.711,406.89,147.254,394.898z"
          />

          {/* ── SIDE MIRROR / TOP TRIM HIGHLIGHT ── */}
          <path
            style={{ opacity: 0.2, fill: '#FFFFFF' }}
            d="M657.203,475.482h52.314l0.203-7.17c0,0-1.385-2.493-3.508-3.879
              c0,0-0.01-0.107-0.025-0.308H654.18C654.875,466.326,656.01,470.209,657.203,475.482z"
          />

          {/* ── FUEL CAP / DETAIL KNOB ── */}
          <path
            style={{ fill: '#529496' }}
            d="M690.113,491.398c-0.849,0-1.578,0.607-1.73,1.442l-1.266,6.897
              c-0.188,1.022,0.495,2.002,1.52,2.181l13.236,2.315l3.325-12.835H690.113z"
          />
          <path
            style={{ fill: '#3C7273' }}
            d="M690.113,491.921c-0.849,0-1.578,0.606-1.73,1.441l-1.266,6.896
              c-0.188,1.023,0.495,2.002,1.52,2.181l13.236,2.316l3.325-12.835H690.113z"
          />

          {/* ── HEADLIGHT HOUSING ── */}
          <g>
            <path
              style={{ fill: '#EBE7C7' }}
              d="M706.188,464.125c-0.242-2.94-2.392-26.304-10.254-39.418c-2.305-0.522-5.887-0.909-7.443-1.173
                c-1.416-0.241-2.631,1.006-2.371,2.418c4.17,22.656,3.856,38.172,3.856,38.172H706.188z"
            />
            <path
              style={{ fill: '#F6921E' }}
              d="M697.26,464.125c-0.867-16.467-6.709-35.74-8.22-40.497c-0.188-0.032-0.374-0.065-0.55-0.094
                c-1.416-0.241-2.631,1.006-2.371,2.418c4.17,22.656,3.856,38.172,3.856,38.172H697.26z"
              className="headlight-glow"
            />
            <path
              style={{ opacity: 0.5, fill: '#404041' }}
              d="M704.977,463.017h-3.137h-10.754c-0.021-3.99-0.367-18.197-3.876-37.265
                c-0.073-0.39,0.098-0.664,0.206-0.794c0.182-0.22,0.446-0.346,0.725-0.346c0.053,0,0.109,0.005,0.164,0.014
                c1.816,0.309,5.146,0.664,6.92,1.058l1.435,0.291c-0.235-0.432-0.476-0.855-0.726-1.268c-2.305-0.522-5.887-0.909-7.443-1.173
                c-0.119-0.021-0.236-0.03-0.35-0.03c-1.261,0-2.26,1.154-2.022,2.448c4.17,22.656,3.856,38.172,3.856,38.172h16.213
                c-0.019-0.238-0.053-0.621-0.099-1.108H704.977z"
            />
          </g>

          {/* ── SILL / BOTTOM STRIP ── */}
          <path
            style={{ fill: '#404041' }}
            d="M697.465,518.296l-0.58-2.519h-34.905l-0.136,4.631h33.939
              C696.893,520.408,697.715,519.377,697.465,518.296z"
          />

          {/* ── TAIL LIGHT SHADE OVERLAY ── */}
          <path
            style={{ opacity: 0.4, fill: '#909596' }}
            d="M147.254,394.898h-5.166h-12.565l-0.208,1.834c0,0,5.756,0,8.906,0
              c3.148,0,2.957,4.982,2.957,4.982l0,0c-1.459,16.385-0.98,47.206-0.98,47.206h5.166
              C145.363,448.92,144.711,406.89,147.254,394.898z"
          />

          {/* ── REAR QUARTER PANEL SHADOW ── */}
          <path
            style={{ opacity: 0.3, fill: '#909596' }}
            d="M185.869,478.701l-71.201-5.036c0.869,5.468,3.576,16.42,11.529,19.026
              c0,0,38.209,8.163,56.124,10.195C182.321,502.886,183.234,491.681,185.869,478.701z"
          />

          {/* ── FRONT WHEEL ARCH HIGHLIGHT ── */}
          <path
            style={{ opacity: 0.2, fill: '#FFFFFF' }}
            d="M661.635,464.125h3.02c-0.513-3.725-1.403-8.16-2.935-13.012
              c-5.078-16.099-24.461-24.177-40.154-27.83c-16.625-3.87-34.752-3.359-50.771,2.557
              c-20.195,7.458-31.936,27.881-31.174,48.448c0,0.01,0,0.02,0,0.03c0.989-5.176,2.984-9.808,4.805-14.872
              c1.752-4.881,4.533-8.811,8.175-12.622c6.253-6.545,15.069-10.395,23.935-12.299c9.969-2.143,20.266-2.895,30.465-2.243
              c14.283,0.913,29.986,4.526,41.716,12.854c5.288,3.754,9.603,8.758,11.603,14.814L661.635,464.125z"
          />

          {/* ── DOOR HANDLE (FRONT) ── */}
          <g>
            <ellipse style={{ opacity: 0.2, fill: '#404041' }} cx="411" cy="419.951" rx="11" ry="8" />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M425.607,416.954l-28.201-1.26c-0.996-0.045-1.838,0.727-1.884,1.723l-0.104,2.311
                c-0.043,0.995,0.729,1.839,1.725,1.884l28.201,1.26c0.996,0.045,1.84-0.727,1.884-1.723l0.103-2.311
                C427.375,417.842,426.603,416.998,425.607,416.954z"
            />
            <path
              style={{ opacity: 0.2, fill: '#404041' }}
              d="M395.463,418.756l-0.045,0.971c-0.043,0.995,0.729,1.839,1.725,1.884l28.201,1.26
                c0.996,0.045,1.84-0.727,1.884-1.723l0.042-0.97L395.463,418.756z"
            />
            <circle style={{ fill: '#404041' }} cx="398.527" cy="418.839" r="1.414" />
          </g>

          {/* ── DOOR HANDLE (REAR) ── */}
          <g>
            <ellipse style={{ opacity: 0.2, fill: '#404041' }} cx="303.5" cy="415.146" rx="11" ry="8" />
            <path
              style={{ fill: '#D0D2D3' }}
              d="M318.113,412.148l-28.201-1.261c-0.996-0.044-1.839,0.727-1.885,1.723l-0.103,2.311
                c-0.044,0.996,0.728,1.839,1.722,1.884l28.202,1.26c0.997,0.045,1.84-0.726,1.885-1.723l0.103-2.311
                C319.881,413.036,319.109,412.193,318.113,412.148z"
            />
            <path
              style={{ opacity: 0.2, fill: '#404041' }}
              d="M287.969,413.951l-0.044,0.971c-0.044,0.996,0.728,1.839,1.722,1.884l28.202,1.26
                c0.997,0.045,1.84-0.726,1.885-1.723l0.043-0.97L287.969,413.951z"
            />
            <circle style={{ fill: '#404041' }} cx="291.034" cy="414.035" r="1.414" />
          </g>

          {/* ── REAR WHEEL ARCH HIGHLIGHT ── */}
          <path
            style={{ opacity: 0.2, fill: '#FFFFFF' }}
            d="M115.893,455.605c29.28-3.417,64.279-3.054,78.828-2.708
              c0.924-1.233,2.067-2.589,3.469-3.978h-68.667l0,0C129.523,448.92,120.119,449.878,115.893,455.605z"
          />

          {/* ── REAR WHEEL ARCH GRADIENT ── */}
          <path
            style={{ opacity: 0.2, fill: '#FFFFFF' }}
            d="M300.803,448.031c-5.077-16.1-24.461-24.178-40.153-27.83
              c-16.626-3.871-34.753-3.361-50.772,2.557c-12.662,4.676-22,14.452-27.018,26.162h4.541
              c1.256-1.794,2.68-3.5,4.281-5.177c6.252-6.546,15.07-10.394,23.934-12.299c9.971-2.142,20.268-2.893,30.465-2.243
              c14.285,0.912,29.986,4.525,41.717,12.854c5.289,3.754,9.603,8.758,11.603,14.814l4.936,15.63
              C304.336,472.499,305.199,461.974,300.803,448.031z"
          />

          {/* ── DOOR PANEL LINE ── */}
          <polygon
            style={{ opacity: 0.3, fill: '#909596' }}
            points="306.086,514.299 542.856,519.471 543.654,513.62 305.023,511.563"
          />

          {/* ── SIDE BODY STRIPE ── */}
          <path
            style={{ opacity: 0.3, fill: '#909596' }}
            d="M297.182,482.506c1.079,5.029,2.068,10.47,2.809,16.095l6.096,15.698l236.77,5.171
              l2.217-16.252c0,0,0.818-8.031,2.713-17.984L297.182,482.506z"
          />

          {/* ── TAIL SECTION SHADOW ── */}
          <path
            style={{ opacity: 0.3, fill: '#909596' }}
            d="M702.889,508.205l-1.016-3.972l3.325-12.835h2.03c0,0,1.551-0.744,1.875-2.556h-49.387
              c1.17,7.713,2.088,16.813,2.263,26.934h34.905C696.885,515.776,701.227,511.991,702.889,508.205z"
          />

          {/* ── WINDOW TRIM STRIPS ── */}
          <path
            style={{ fill: '#6CA4B7' }}
            d="M530.66,440.58l-137.918-3.081c-1.132-0.025-2.069,0.872-2.096,2.004l-0.014,0.602
              c-0.024,1.133,0.871,2.07,2.006,2.096l137.916,3.081c1.133,0.024,2.07-0.873,2.096-2.004l0.014-0.602
              C532.69,441.543,531.791,440.605,530.66,440.58z"
          />
          <path
            style={{ fill: '#6CA4B7' }}
            d="M379.507,437.203l-72.182-1.613c-1.132-0.025-2.069,0.872-2.096,2.004l-0.013,0.603
              c-0.025,1.132,0.869,2.07,2.002,2.095l72.184,1.612c1.133,0.026,2.07-0.872,2.096-2.003l0.014-0.603
              C381.537,438.167,380.641,437.228,379.507,437.203z"
          />
          <path
            style={{ opacity: 0.4, fill: '#909596' }}
            d="M379.402,441.905l-72.184-1.612c-1.046-0.023-1.885-0.833-1.984-1.851
              c-0.01,0.081-0.027,0.161-0.029,0.244l-0.013,0.604c-0.024,1.131,0.872,2.069,2.003,2.095l72.184,1.613
              c1.132,0.025,2.07-0.872,2.095-2.004l0.015-0.604c0.002-0.083-0.012-0.163-0.02-0.245
              C381.324,441.158,380.45,441.928,379.402,441.905z"
          />
          <path
            style={{ opacity: 0.4, fill: '#909596' }}
            d="M530.555,445.282l-137.916-3.081c-1.049-0.023-1.887-0.833-1.986-1.85
              c-0.012,0.081-0.027,0.16-0.029,0.244l-0.014,0.602c-0.025,1.133,0.872,2.071,2.004,2.096l137.916,3.082
              c1.133,0.026,2.071-0.872,2.098-2.004l0.013-0.603c0.001-0.083-0.011-0.164-0.021-0.245
              C532.475,444.534,531.604,445.305,530.555,445.282z"
          />

          {/* ── INTERIOR REAR PILLAR ── */}
          <path
            style={{ fill: '#162026' }}
            d="M502.629,394.191l-4.199,6.32l1.639,8.441c0.187,0.951,1.018,1.638,1.989,1.638h9.3
              c0,0,6.283-5.221,6.379-10.079C517.834,395.653,502.629,394.191,502.629,394.191z"
          />

          {/* ── FUEL FILLER FLAP ── */}
          <g>
            <path
              style={{ fill: '#558AA2' }}
              d="M487.752,397.338l-1.537-14.935c0,0-0.033-2.434,4.35-2.885c0,0,9.734,0.124,13.4,4.246
                c0,0,5.292,7.33,7.393,16.208c0,0-0.783,3.924-3.477,4.014c0,0-9.786,0.444-14.504-1.321
                C493.377,402.665,488.057,400.306,487.752,397.338z"
            />
            <path
              style={{ opacity: 0.2, fill: '#FFFFFF' }}
              d="M490.565,379.518c-0.422,0.044-0.802,0.105-1.147,0.182
                c3.051,3.005,11.861,12.448,15.323,24.334c1.856,0.01,3.14-0.048,3.14-0.048c2.693-0.089,3.477-4.014,3.477-4.014
                c-2.101-8.877-7.393-16.208-7.393-16.208C500.299,379.643,490.565,379.518,490.565,379.518z"
            />
          </g>

          {/* ── HEADLIGHT LENS GLARE ── */}
          <path
            style={{ opacity: 0.3, fill: '#FFFFFF' }}
            d="M695.934,424.707c-2.305-0.522-5.887-0.909-7.443-1.173
              c-0.91-0.155-1.736,0.308-2.142,1.032c3.765,3.707,10.993,11.797,17.798,24.845
              C702.617,441.311,700.063,431.596,695.934,424.707z"
          />

          {/* ── BODY SIDE CHROME HIGHLIGHT ── */}
          <path
            style={{ opacity: 0.2, fill: '#FFFFFF' }}
            d="M694.254,422.186c0,0-5.956-6.094-23.963-10.25c0,0-51.344-11.774-109.89-15.838l0,0
              c0,0.001,6.567,9.342,24.206,11.822c15.643,2.2,71.924,7.205,110.64,15.689
              C694.926,423.118,694.595,422.642,694.254,422.186z"
          />

          {/* ── DOOR HINGE MOUNTS ── */}
          <path
            style={{ fill: '#EBE7C7' }}
            d="M128.451,438.938h4.697c1.559,0,2.822-1.264,2.822-2.824V433.1c0-1.561-1.264-2.825-2.822-2.825
              h-5.191C128.058,433.084,128.217,435.982,128.451,438.938z"
          />
          <path
            style={{ fill: '#EBE7C7' }}
            d="M128.012,413.069h5.137c1.559,0,2.822-1.264,2.822-2.824v-3.014
              c0-1.56-1.264-2.824-2.822-2.824h-4.62C128.33,406.907,128.145,409.825,128.012,413.069z"
          />

          {/* ── WINDSHIELD GLARE STREAKS ── */}
          <g clipPath="url(#windshieldClip)">
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="408.451,323.692 358.75,430.274 403.3,430.274 453,323.692" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="339.352,323.692 289.649,430.274 305.523,430.274 355.223,323.692" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="474.953,323.692 425.252,430.274 451.484,430.274 501.185,323.692" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="372.137,323.692 322.438,430.274 332.679,430.274 382.38,323.692" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="386.158,323.692 336.459,430.274 343.058,430.274 392.758,323.692" />
          </g>

          {/* ── WINDOW DIVIDER / B-PILLAR ── */}
          <path
            style={{ fill: '#1F1916' }}
            d="M381.299,339.855c-2.424,13.951-4.627,46.753-5.678,64.152c8.104,0.371,16.497,0.745,24.949,1.107
              c-2.016-24.897,1.04-55.16,2.078-64.278C395.582,340.464,388.384,340.138,381.299,339.855z"
          />

          {/* ── REAR WINDOW GLARE STREAKS ── */}
          <g clipPath="url(#rearWindowClip)">
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="237.662,326.233 195.58,416.479 233.301,416.479 275.383,326.233" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="179.152,326.233 137.071,416.479 150.512,416.479 192.594,326.233" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="293.969,326.233 251.887,416.479 274.098,416.479 316.182,326.233" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="206.914,326.233 164.832,416.479 173.504,416.479 215.588,326.233" />
            <polygon style={{ opacity: 0.25, fill: '#FFFFFF' }} points="218.787,326.233 176.705,416.479 182.293,416.479 224.373,326.233" />
          </g>

          <defs>
            <clipPath id="windshieldClip">
              <path d="M288.74,377.82c0.863-3.087,2.238-6.098,3.389-8.986c2.74-6.901,5.658-13.795,9.268-20.294
                c0.563-1.014,1.143-2.018,1.758-3.001c0.314-0.5,1.639-1.896,1.639-2.444c0,0,2.586-4.986,9.234-4.986
                c0,0,89.064,0.97,131.867,6.094c0,0,19.761,3.325,32.137,13.759l36.566,30.198c0,0,11.451,16.252-7.202,19.207
                c-18.653,2.954-202.419-6.833-202.419-6.833s-5.539-0.555-9.049-4.433c-2.252-2.489-5.801-5.27-7.252-8.305
                c-0.305-0.635-0.467-1.328-0.582-2.023C287.647,383.084,288.012,380.425,288.74,377.82z" />
            </clipPath>
            <clipPath id="rearWindowClip">
              <path d="M147.254,394.898c0,0,15.236-39.615,30.195-54.852c0,0,76.184-1.661,98.348-1.939
                c0,0,6.094,1.478,2.029,8.311l-25.485,42.294c0,0-4.064,6.186-11.081,6.186
                C234.241,394.898,147.254,394.898,147.254,394.898z" />
            </clipPath>
          </defs>

          {/* ── EXHAUST SMOKE (visible on error) ── */}
          {hasError && (
            <g className="exhaust-smoke">
              <circle className="smoke-particle smoke-1" cx="105" cy="495" r="8" fill="#888" opacity="0" />
              <circle className="smoke-particle smoke-2" cx="100" cy="500" r="11" fill="#999" opacity="0" />
              <circle className="smoke-particle smoke-3" cx="108" cy="505" r="6" fill="#777" opacity="0" />
              <circle className="smoke-particle smoke-4" cx="95"  cy="492" r="9" fill="#aaa" opacity="0" />
              <circle className="smoke-particle smoke-5" cx="102" cy="510" r="7" fill="#888" opacity="0" />
              <circle className="smoke-particle smoke-6" cx="112" cy="498" r="10" fill="#999" opacity="0" />
            </g>
          )}
        </g>
      </svg>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to   { transform: rotate(360deg); }
        }
        .headlight-glow {
          animation: headlightPulse 1.5s ease-in-out infinite;
        }
        @keyframes headlightPulse {
          0%, 100% { opacity: 1; }
          50%       { opacity: 0.6; }
        }

        /* ── Error: car shake ── */
        .car-error {
          animation: carShake 0.4s ease-in-out 3;
        }
        @keyframes carShake {
          0%, 100% { transform: translateX(0); }
          20%      { transform: translateX(-6px) rotate(-1deg); }
          40%      { transform: translateX(5px) rotate(1deg); }
          60%      { transform: translateX(-4px) rotate(-0.5deg); }
          80%      { transform: translateX(3px) rotate(0.5deg); }
        }

        /* ── Exhaust smoke puffs ── */
        @keyframes smokePuff {
          0%   { opacity: 0; transform: translate(0, 0) scale(1); }
          15%  { opacity: 0.6; }
          50%  { opacity: 0.4; transform: translate(-30px, -20px) scale(1.8); }
          100% { opacity: 0;   transform: translate(-60px, -40px) scale(2.5); }
        }
        .smoke-1 { animation: smokePuff 1.2s ease-out 0s 3; }
        .smoke-2 { animation: smokePuff 1.4s ease-out 0.15s 3; }
        .smoke-3 { animation: smokePuff 1.1s ease-out 0.3s 3; }
        .smoke-4 { animation: smokePuff 1.5s ease-out 0.1s 3; }
        .smoke-5 { animation: smokePuff 1.3s ease-out 0.25s 3; }
        .smoke-6 { animation: smokePuff 1.6s ease-out 0.05s 3; }
      `}</style>
    </>
  );
};

export default AnimatedCar;